// assets
import {
  IconDashboard,
  IconSitemap,
  IconArticle,
  IconCoin,
  IconAdjustments,
  IconKey,
  IconGardenCart,
  IconUser,
  IconUserScan,
  IconGlobe,
  IconCloud,
  IconApiApp
} from '@tabler/icons-react';

import { ReactComponent as CustomIcon1 } from 'assets/images/icons/1.svg';
import { ReactComponent as CustomIcon2 } from 'assets/images/icons/2.svg';
import { ReactComponent as CustomIcon3 } from 'assets/images/icons/3.svg';
import { ReactComponent as CustomIcon4 } from 'assets/images/icons/4.svg';
import { ReactComponent as CustomIcon5 } from 'assets/images/icons/5.svg';
import { ReactComponent as CustomIcon6 } from 'assets/images/icons/6.svg';

// constant
const icons = { IconDashboard, IconSitemap, IconArticle, IconCoin, IconAdjustments, IconKey, IconGardenCart, IconUser, IconUserScan,IconGlobe,IconCloud,IconApiApp };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const panel = {
  id: 'panel',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: '控制台',
      type: 'item',
      url: '/panel/dashboard',
      icon: CustomIcon1,
      iconSize: '1.5rem',
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'channel',
      title: '渠道',
      type: 'item',
      url: '/panel/channel',
      icon: icons.IconSitemap,
      iconSize: '1.4rem',
      iconColor: 'secondary',
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'token',
      title: 'API令牌',
      type: 'item',
      url: '/panel/token',
      icon: CustomIcon2,
      breadcrumbs: false
    },
    {
      id: 'model',
      title: '模型列表',
      type: 'item',
      url: '/panel/model',
      icon: CustomIcon3,
      breadcrumbs: false
    },
    {
      id: 'log',
      title: '日志',
      type: 'item',
      url: '/panel/log',
      icon: icons.IconArticle,
      breadcrumbs: false,
      isAdmin: true

    },{
      id: 'history',
      title: '使用日志',
      type: 'item',
      url: '/panel/history',
      icon: CustomIcon4,
      breadcrumbs: false,
    },
    {
      id: 'redemption',
      title: '兑换',
      type: 'item',
      url: '/panel/redemption',
      icon: icons.IconCoin,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'topup',
      title: '钱包充值',
      type: 'item',
      url: '/panel/topup',
      icon: CustomIcon5,
      breadcrumbs: false
    },
    // {
    //   id: 'multi-tab',
    //   title: 'Mojie API',
    //   type: 'collapse', // 改为collapse类型表示可展开
    //   icon: icons.IconApiApp,
    //   children: [ // 添加子菜单项
    //     {
    //       id: 'tab1',
    //       title: 'AI服装模特',
    //       type: 'item',
    //       url: '/api/clothes',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'tab2',
    //       title: 'qwen 文生图',
    //       type: 'item',
    //       url: '/api/qwen-image',
    //       breadcrumbs: false
    //     },
    //     {
    //       id: 'tab3',
    //       title: 'qwen 图片编辑',
    //       type: 'item',
    //       url: '/api/qwen-image-edit',
    //       breadcrumbs: false
    //     }
    //   ]
    // },
    {
      id: 'user',
      title: '用户',
      type: 'item',
      url: '/panel/user',
      icon: icons.IconUser,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'profile',
      title: '个人设置',
      type: 'item',
      url: '/panel/profile',
      icon: CustomIcon6,
      breadcrumbs: false,
      isAdmin: false
    },
    {
      id: 'setting',
      title: '设置',
      type: 'item',
      url: '/panel/setting',
      icon: icons.IconAdjustments,
      breadcrumbs: false,
      isAdmin: true
    },
    {
      id: 'system',
      title: '系统',
      type: 'item',
      url: '/panel/system',
      icon: icons.IconCloud,
      breadcrumbs: false,
      isAdmin: true
    }
  ]
};

export default panel;
